import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IReport6Report } from "./Report6Report";

export interface TReport6ReportingPeriod {
  reportingPeriodId: number;
  name: string;
  additionalEvaluation: boolean;
  additionalEvaluationReason: string;
  additionalEvaluationStatus: string;
  additionalEvaluationDate: Date;
  applicantId: number;
  applicantReportingPeriodId: number;
}

export interface IReport6ReportingPeriod extends TReport6ReportingPeriod {
  reports: IReport6Report[];
}

const Report6ReportingPeriod = Model(
  (model: TReport6ReportingPeriod): IReport6ReportingPeriod => {
    const _report6ReportingPeriod: TReport6ReportingPeriod = Object.assign(
      {},
      model
    );

    let create = (
      report6ReportingPeriod: IReport6ReportingPeriod
    ): IReport6ReportingPeriod => {
      let obj = ValidatableObject(report6ReportingPeriod);
      return obj;
    };

    let _reports: IReport6Report[] = [];

    let report6ReportingPeriod = {
      get reportingPeriodId() {
        return _report6ReportingPeriod.reportingPeriodId;
      },
      set reportingPeriodId(value) {
        _report6ReportingPeriod.reportingPeriodId = value;
      },
      get name() {
        return _report6ReportingPeriod.name;
      },
      set name(value) {
        _report6ReportingPeriod.name = value;
      },
      get additionalEvaluation() {
        return _report6ReportingPeriod.additionalEvaluation;
      },
      set additionalEvaluation(value) {
        _report6ReportingPeriod.additionalEvaluation = value;
      },
      get additionalEvaluationReason() {
        return _report6ReportingPeriod.additionalEvaluationReason;
      },
      set additionalEvaluationReason(value) {
        _report6ReportingPeriod.additionalEvaluationReason = value;
      },
      get additionalEvaluationStatus() {
        return _report6ReportingPeriod.additionalEvaluationStatus;
      },
      set additionalEvaluationStatus(value) {
        _report6ReportingPeriod.additionalEvaluationStatus = value;
      },
      get additionalEvaluationDate() {
        return _report6ReportingPeriod.additionalEvaluationDate;
      },
      set additionalEvaluationDate(value) {
        _report6ReportingPeriod.additionalEvaluationDate = value;
      },
      get applicantId() {
        return _report6ReportingPeriod.applicantId;
      },
      set applicantId(value) {
        _report6ReportingPeriod.applicantId = value;
      },
      get applicantReportingPeriodId() {
        return _report6ReportingPeriod.applicantReportingPeriodId;
      },
      set applicantReportingPeriodId(value) {
        _report6ReportingPeriod.applicantReportingPeriodId = value;
      },
      get reports() {
        return _reports;
      },
      set reports(value) {
        _reports = value;
      }
    };
    return create(report6ReportingPeriod);
  }
);
export default Report6ReportingPeriod;
